import * as React from "react";
const SvgFiRrAssessmentAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-assessment-alt_svg__a)">
      <path
        fill="#062147"
        d="M23.068 8.932a3.187 3.187 0 0 0-4.5 0l-5.104 5.104A4.97 4.97 0 0 0 12 17.571V19a1 1 0 0 0 1 1h1.429c1.335 0 2.59-.521 3.536-1.465l5.104-5.104a3.187 3.187 0 0 0 0-4.5zm-1.414 3.086-5.104 5.104a2.99 2.99 0 0 1-2.122.879h-.429v-.429c0-.79.32-1.562.878-2.121l5.104-5.104a1.182 1.182 0 0 1 1.671 1.672zm-5.622-6.142a.995.995 0 0 1 1.219-.718c.438.112.858.285 1.25.511a1 1 0 0 1-1 1.732 3 3 0 0 0-.75-.308 1 1 0 0 1-.718-1.218zm4.299 15.625A5.02 5.02 0 0 1 16 24H8c-2.757 0-5-2.243-5-5v-2a1 1 0 1 1 2 0v2c0 1.654 1.346 3 3 3h8a3.01 3.01 0 0 0 2.599-1.501 1 1 0 0 1 1.366-.364 1 1 0 0 1 .366 1.366M14 7c0-3.859-3.14-7-7-7S0 3.141 0 7s3.14 7 7 7 7-3.141 7-7M2 7c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5m5.98 2.326a2.35 2.35 0 0 1-1.653.671 2.38 2.38 0 0 1-1.664-.674L3.531 8.215a1 1 0 0 1 1.399-1.43l1.132 1.108a.374.374 0 0 0 .522 0l2.223-2.134a1 1 0 0 1 1.385 1.443z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-assessment-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAssessmentAlt;
